import React from 'react';

const Dropdown = ({ trigger, menu, divClass, menuClass, onChildClose }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  // Handle closing the dropdown, notifying parent if necessary
  const handleClose = () => {
    setOpen(false);
    if (onChildClose) {
      onChildClose(); // Notify parent when this dropdown closes
    }
  };

  if (divClass === undefined) {
    divClass = 'dropdown';
  }

  if (menuClass === undefined) {
    menuClass = 'menu';
  }

  return (
    <div className={divClass}>
      {React.cloneElement(trigger, {
        onClick: handleOpen,
      })}
      {open ? (
        <ul className={menuClass}>
          {menu.map((menuItem, index) => (
            <li key={index} className="menu-item">
              {React.isValidElement(menuItem)
                ? // Pass onChildClose to any valid React element
                  React.cloneElement(menuItem, {
                    onChildClose: handleClose, // Pass callback to child
                    onClick: menuItem.props.onClick
                      ? () => {
                          menuItem.props.onClick();
                          handleClose(); // Close this dropdown
                        }
                      : undefined,
                  })
                : // Fallback for non-React elements (though unlikely in your case)
                  menuItem}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default Dropdown;